import { formatPhone, whatsappLink } from '@takumi/shared';
import { Mail, MessageCircle, Phone } from 'lucide-react';
import { Tooltip } from '@/components/ui/primitives';
import { cn } from '@/lib/utils';

/**
 * Click-to-call / click-to-chat / mail links. These open the phone, WhatsApp or mail client;
 * they do not send anything by themselves (the official WhatsApp API send lives in Phase 5).
 */
export function ContactActions({
  phone,
  whatsapp,
  email,
  onAction,
  size = 'sm',
  className,
}: {
  phone?: string | null;
  whatsapp?: string | null;
  email?: string | null;
  onAction?: (type: 'call' | 'whatsapp' | 'email') => void;
  size?: 'sm' | 'md';
  className?: string;
}) {
  const btn = cn(
    'grid place-items-center rounded-control border border-line bg-surface text-ink-soft transition-colors hover:border-matcha-400 hover:bg-matcha-50 hover:text-matcha-800',
    size === 'sm' ? 'size-8 [&_svg]:size-4' : 'size-9 [&_svg]:size-[18px]',
  );
  const wa = whatsappLink(whatsapp);
  return (
    <div className={cn('flex items-center gap-1', className)} onClick={(e) => e.stopPropagation()}>
      {phone && (
        <Tooltip content={`התקשרות · ${formatPhone(phone)}`}>
          <a href={`tel:${phone}`} className={btn} aria-label="התקשרות" onClick={() => onAction?.('call')}>
            <Phone />
          </a>
        </Tooltip>
      )}
      {wa && (
        <Tooltip content="פתיחת צ׳אט WhatsApp">
          <a href={wa} target="_blank" rel="noopener noreferrer" className={cn(btn, 'hover:border-[#25d366] hover:bg-[#25d366]/10 hover:text-[#128c4a]')} aria-label="WhatsApp" onClick={() => onAction?.('whatsapp')}>
            <MessageCircle />
          </a>
        </Tooltip>
      )}
      {email && (
        <Tooltip content={email}>
          <a href={`mailto:${email}`} className={btn} aria-label="אימייל" onClick={() => onAction?.('email')}>
            <Mail />
          </a>
        </Tooltip>
      )}
    </div>
  );
}

export function PhoneText({ value }: { value: string | null | undefined }) {
  if (!value) return null;
  return <span className="ltr tabular">{formatPhone(value)}</span>;
}
